<template>
    <div class="collbar-page">
      <div class="menu">
        <!-- <div class="menu-header flex-row-justify-space-between"> -->
          <!-- <p class="font-bold font-size-30 flex-center">{{clients.collectionTheme}}</p> -->
          <!-- 数字特藏 -->
          <!-- <p class="font-size-14 font-color-264480 flex-center font-bold cursor" @click="changeAllMenu">{{ menuAllShow?'全部收起':'全部展开' }}</p> -->
        <!-- </div> -->
        <div class="menu-content">
  
          <!-- 分类 -->
          <div v-if="menu && menu.sideNavigation && menu.sideNavigation.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">分类</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.categoryId.show?'transform':''" data-typ="categoryId" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.categoryId.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-if="currentLogs.parent" class="menu-content-item-list-item">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5 sel">
                      <p class="font-size-14 font-color-white">{{ currentLogs.parent.cateName }}</p>
                      <p class="font-size-14 cate-sel-close flex-center cursor font-color-white" @click="selectLastCate">x</p>
                    </div>
                  </div>
                  <div v-for="cate in currentLogs.logs" :key="cate.id" class="menu-content-item-list-item" @click="selectCate(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.categoryId.current == cate.id?'sel':''">
                      <div class="flex">
                        <p v-if="currentLogs.parent" class="font-size-14 character">└</p>
                        <p class="font-size-14">{{ cate.cateName }}</p>
                      </div>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 学科 -->
          <div v-if="menu && menu.subjectNavigation && menu.subjectNavigation.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">学科</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.subjects.show?'transform':''" data-typ="subjects" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.subjects.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-if="currentSubject.parent" class="menu-content-item-list-item">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5 sel">
                      <p class="font-size-14">{{ currentSubject.parent.subjectName }}</p>
                      <p class="font-size-14 cate-sel-close flex-center cursor font-color-white" @click="selectLastSubject">x</p>
                    </div>
                  </div>
                  <div v-for="cate in currentSubject.logs" :key="cate.id" class="menu-content-item-list-item" @click="selectSubject(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.subjects.current == cate.id?'sel':''">
                      <p class="font-size-14">{{ cate.subjectName }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 资源类型 -->
          <div v-if="menu && menu.resourceType && menu.resourceType.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">资源类型</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.resourceType.show?'transform':''" data-typ="resourceType" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.resourceType.show">
              <div v-if="menu.resourceType && menu.resourceType.length">
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.resourceType" :key="cate.name" class="menu-content-item-list-item" @click="selectFileType(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.resourceType.current == cate.code?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 专题 -->
          <!-- <div v-if="menu && menu.specialSubject && menu.specialSubject.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">专题</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.specialSubject.show?'transform':''" data-typ="specialSubject" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.specialSubject.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.specialSubject" :key="cate.topicName" class="menu-content-item-list-item" @click="selectTopic(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.specialSubject.current==cate.id?'sel':''">
                      <p class="font-size-14">{{ cate.topicName }}</p>
                      <p v-if="cate.countategory>0" class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
  
                <div v-if="menu.specialSubjectTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="topic" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
              </div>
  
            </div>
          </div> -->
  
          <!-- 纪事地点 -->
          <div v-if="menu && menu.regionNavigation && menu.regionNavigation.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">纪事地点</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.areaAffected.show?'transform':''" data-typ="region" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.areaAffected.show">
              <div v-if="menu.regionNavigation && menu.regionNavigation.length">
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-if="currentRegion.parent" class="menu-content-item-list-item">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5 sel">
                      <p class="font-size-14 font-color-white">{{ currentRegion.parent.regionName }}</p>
                      <p class="font-size-14 cate-sel-close flex-center cursor font-color-white" @click="selectLastRegion">x</p>
                    </div>
                  </div>
                  <div v-for="cate in currentRegion.logs" :key="cate.regionCode" class="menu-content-item-list-item" @click="selectRegion(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.areaAffected.current == cate.id?'sel':''">
                      <div class="flex">
                        <p v-if="currentRegion.parent" class="font-size-14 character">└</p>
                        <p class="font-size-14">{{ cate.regionName }}</p>
                      </div>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="menu.regionNavigationTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="region" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
              </div>
            </div>
  
          </div>
  
          <!-- 纪事人物 -->
          <div v-if="menu && menu.figureNavigation && menu.figureNavigation.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">纪事人物</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.personAffected.show?'transform':''" data-typ="personAffected" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.personAffected.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.figureNavigation" :key="cate.personName" class="menu-content-item-list-item" @click="selectPerson(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.personAffected.current == cate.personName?'sel':''">
                      <p class="font-size-14">{{ cate.personName }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.total }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="menu.figureNavigationTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="person" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 纪事年份 -->
          <div v-if="menu && menu.chronicleDate && menu.chronicleDate.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">纪事年份</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.chronicleDates.show?'transform':''" data-typ="chronicleDates" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.chronicleDates.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.chronicleDate" :key="cate.name" class="menu-content-item-list-item" @click="selectDate(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.chronicleDates.current == cate.name?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="menu.chronicleDateTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="date" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
                <div class="flex-center" style="padding: 15px 20px; border-top: 1px solid #eee;">
                  <div class="menu-content-item-list-item-rang flex-row-align-center position-relative bg-white radius-clip-5 flex-1">
                    <el-date-picker
                      v-model="menuDisplay.chronicleDates.rangeDate"
                      :editable="false"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder=""
                      end-placeholder=""
                      size="mini"
                      clear-icon=""
                      prefix-icon=""
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd"
                    />
                  </div>
                  <div class="font-color-white font-size-14 bg-282B80 radius-clip-5 flex-center cursor menu-content-item-list-item-button" @click="selectDate">确认</div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 馆藏级别 -->
          <div v-if="menu && menu.collectionLevel && menu.collectionLevel.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">馆藏级别</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.collectionLevel.show?'transform':''" data-typ="collectionLevel" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.collectionLevel.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.collectionLevel" :key="cate.dictValue" class="menu-content-item-list-item" @click="selectLevel(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.collectionLevel.current == cate.dictKey?'sel':''">
                      <p class="font-size-14">{{ cate.dictValue }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 发布人 -->
          <div v-if="menu && menu.publisherNavigation && menu.publisherNavigation.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">发布人</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.commitBy.show?'transform':''" data-typ="commitBy" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.commitBy.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.publisherNavigation" :key="cate.userId" class="menu-content-item-list-item" @click="selectPubMan(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.commitBy.current == cate.userId?'sel':''">
                      <p class="font-size-14">{{ cate.userName }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.total }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="menu.publisherNavigationTotal>5" class="flex-row-justify-end menu-content-item-more">
                <div class="flex-row-align-center" data-typ="pubman" @click="showMore">
                  <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                  <img src="@/assets/icon-lib-arrow.png">
                </div>
              </div>
            </div>
          </div>
  
          <!-- 发布日期 -->
          <div v-if="menu && menu.releasedate && menu.releasedate.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">发布日期</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.releaseDates.show?'transform':''" data-typ="releaseDates" @click="closeMenu">
            </div>
            <div v-if="menuDisplay.releaseDates.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.releasedate" :key="cate.name" class="menu-content-item-list-item" @click="selectPubDate(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.releaseDates.current == cate.name?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
  
                <div v-if="menu.releasedateTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="pubdate" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
  
                <div class="flex-center" style="padding: 15px 20px; border-top: 1px solid #eee;">
                  <div class="menu-content-item-list-item-rang flex-row-align-center position-relative bg-white radius-clip-5 flex-1">
                    <el-date-picker
                      v-model="menuDisplay.releaseDates.rangeDate"
                      type="datetimerange"
                      :editable="false"
                      range-separator="至"
                      start-placeholder=""
                      end-placeholder=""
                      size="mini"
                      clear-icon=""
                      prefix-icon=""
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd"
                    />
                  </div>
                  <div class="font-color-white font-size-14 bg-282B80 radius-clip-5 flex-center cursor menu-content-item-list-item-button" @click="selectPubDate">确认</div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 版权 -->
          <div v-if="menu && menu.copyright && menu.copyright.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">版权</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.copyrightOwner.show?'transform':''" data-typ="copyrightOwner" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.copyrightOwner.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.copyright" :key="cate.dictValue" class="menu-content-item-list-item" @click="selectCopyRight(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.copyrightOwner.current == cate.dictKey?'sel':''">
                      <p class="font-size-14">{{ cate.dictValue }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 权限范围 -->
          <div v-if="menu && menu.scopeOfAuthorization && menu.scopeOfAuthorization.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">权限范围</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.permissionRanges.show?'transform':''" data-typ="permissionRanges" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.permissionRanges.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.scopeOfAuthorization" :key="cate.dictValue" class="menu-content-item-list-item" @click="selectRange(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.permissionRanges.current == cate.dictKey?'sel':''">
                      <p class="font-size-14">{{ cate.dictValue }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script> 
   // import api from '../../../../../api/home.js'
   import api from '@/api/home.js'
  
  export default {
    props: {
      menu: {
        type: Object,
        default: null
      },
      params: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        clients: null,
        prepeared: false,
        currentCate: null,
        currentLogs: null,
        currentSubject: null,
        currentRegion: null,
        menuAllShow: false,
        menuDisplay: {
          categoryId: {
            show: false,
            current: null
          }, subjects: {
            show: false,
            current: null
          }, resourceType: {
            show: false,
            current: null
          }, specialSubject: {
            show: false,
            current: null
          }, areaAffected: {
            show: false,
            current: null
          }, personAffected: {
            show: false,
            current: null
          }, chronicleDates: {
            show: false,
            rangeDate: '',
            current: null
          }, collectionLevel: {
            show: false,
            current: null
          }, commitBy: {
            show: false,
            current: null
          }, releaseDates: {
            show: false,
            rangeDate: '',
            current: null
          }, copyrightOwner: {
            show: false,
            current: null
          }, permissionRanges: {
            show: false,
            current: null
          }
        }
      }
    },
    watch: {
      menu() {
        this.prepearData()
      }
    },
    created() {
      this.prepearData();
      let that = this;
      setTimeout(() => {
        that.clients = that.$store.getters.application  
      }, 1500);
    },
    methods: {
    
      prepearData() {
        if (this.menu) {
          const cates = this.menu.sideNavigation
          const subject = this.menu.subjectNavigation
          const region = this.menu.regionNavigation
          if (!this.currentLogs) {
            this.menuAllShow = false
  
            this.changeAllMenu()
          }
          if (!this.currentLogs || (this.currentLogs && !this.currentLogs.parent)) {
            this.currentLogs = { parent: null, logs: cates }
          }
          if (!this.currentSubject || (this.currentSubject && !this.currentSubject.parent)) {
            this.currentSubject = { parent: null, logs: subject }
          }
          if (!this.currentRegion | (this.currentRegion && !this.currentRegion.parent)) {
            this.currentRegion = { parent: null, logs: region }
          }
  
          this.prepeared = true
        }
      },
      changeAllMenu() {
        this.menuAllShow = !this.menuAllShow
        for (const key in this.menuDisplay) {
          if (Object.hasOwnProperty.call(this.menuDisplay, key)) {
            const value = this.menuDisplay[key]
            value.show = this.menuAllShow
          }
        }
      },
      closeMenu(v) {
        const type = v.currentTarget.dataset.typ
        this.menuDisplay[type].show = !this.menuDisplay[type].show
      },
      showMore(v) {
        this.$emit('showMore', { type: v.currentTarget.dataset.typ })
      },
  
      // 多级点击事件---------------------------
      // 分类点击事件
      selectCate(v) {
        if (this.menuDisplay.categoryId.current === v.cateName) {
          return
        }
        this.menuDisplay.categoryId.current = v.id
        if (v.children && v.children.length) {
          this.currentLogs = { parent: v, logs: v.children }
        } else {
          // this.$emit('params', { params: { categoryId: v.id }, display: v.cateName, type: 'categoryId' })
        }
        this.$emit('params', { params: { categoryId: v.id }, display: v.cateName, type: 'categoryId' })
      },
      selectLastCate() {
        if (this.currentLogs.parent.parentId === 0) {
          this.currentLogs = { parent: null, logs: this.menu.sideNavigation }
          this.menuDisplay.categoryId.current = null
          this.$emit('remove', { type: 'categoryId' })
        } else {
          const parentId = this.currentLogs.parent.parentId
          this.findCatesById(parentId, this.menu.sideNavigation)
        }
      },
      findCatesById(cid, cates) {
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.id === cid) {
            this.currentLogs = { parent: cate, logs: cate.children }
            this.$emit('params', { params: { categoryId: cate.id }, display: cate.cateName, type: 'categoryId' })
            return cate
          } else {
            if (cate.children.length) {
              this.findCatesById(cid, cate.children)
            }
          }
        }
      },
  
      // 学科点击事件
      selectSubject(v) {
        if (this.menuDisplay.subjects.current === v.id) {
          return
        }
        this.menuDisplay.subjects.current = v.id
        if (v.children && v.children.length) {
          this.currentSubject = { parent: v, logs: v.children }
        } else {
          // this.$emit('params', { params: { subjects: v.id }, display: v.subjectName, type: 'subjects' })
        }
        this.$emit('params', { params: { subjects: v.id }, display: v.subjectName, type: 'subjects' })
      },
      selectLastSubject() {
        if (this.currentSubject.parent.parentId === 0) {
          this.currentSubject = { parent: null, logs: this.menu.subjectNavigation }
          this.menuDisplay.subjects.current = null
          this.$emit('remove', { type: 'subjects' })
        } else {
          const parentId = this.currentSubject.parent.parentId
          this.findSubjectsById(parentId, this.menu.subjectNavigation)
        }
      },
      findSubjectsById(cid, cates) {
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.id === cid) {
            this.currentSubject = { parent: cate, logs: cate.children }
            this.$emit('params', { params: { subjects: cate.id }, display: cate.subjectName, type: 'subjects' })
            // return cate
          } else {
            if (cate.children) {
              this.findSubjectsById(cid, cate.children)
            }
          }
        }
      },
  
      // 纪事地点事件
      selectRegion(v) {
        if (this.menuDisplay.areaAffected.current === v.id) {
          return
        }
        this.menuDisplay.areaAffected.current = v.id
        if (v.children) {
          this.currentRegion = { parent: v, logs: v.children }
        } else {
          // this.$emit('params', { params: { areaAffected: v.regionCode }, display: v.regionName, type: 'areaAffected' })
        }
        this.$emit('params', { params: { areaAffected: v.regionCode }, display: v.regionName, type: 'areaAffected' })
      },
      selectLastRegion() {
        if (this.currentRegion.parent.parentId === 1) {
          this.currentRegion = { parent: null, logs: this.menu.regionNavigation }
          this.menuDisplay.areaAffected.current = null
          this.$emit('remove', { type: 'areaAffected' })
        } else {
          const parentId = this.currentRegion.parent.parentId
          this.findRegionsById(parentId, this.menu.regionNavigation)
        }
      },
      findRegionsById(cid, cates) {
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.id === cid) {
            this.currentRegion = { parent: cate, logs: cate.children }
            this.$emit('params', { params: { areaAffected: cate.regionCode }, display: cate.regionName, type: 'areaAffected' })
            return cate
          } else {
            if (cate.children) {
              this.findRegionsById(cid, cate.children)
            }
          }
        }
      },
      // menu 点击事件
      selectRange(r) {
        console.log(r)
        this.menuDisplay.permissionRanges.current = r.dictKey
        this.$emit('params', { params: { permissionRanges: r.dictKey }, data: r, display: r.dictValue, type: 'permissionRanges' })
      },
      selectCopyRight(r) {
        this.menuDisplay.copyrightOwner.current = r.dictKey
        this.$emit('params', { params: { copyrightOwner: r.dictKey }, display: r.dictValue, type: 'copyrightOwner' })
      },
      selectPubDate(r) {
        if (r.name) {
          this.menuDisplay.releaseDates.current = r.name
          this.$emit('params', { params: { releaseDates: r.name }, data: r, display: r.name, type: 'releaseDates' })
        } else {
          if (this.menuDisplay.releaseDates.rangeDate.length) {
            const range = this.menuDisplay.releaseDates.rangeDate
            this.$emit('params', { params: { releaseDateStarts: range[0] || '', releaseDateEnd: range[1] || '' }, data: null, display: (range[0] || '') + '-' + (range[1] || ''), type: 'releaseDates' })
          }
        }
      },
      selectPubMan(r) {
        this.menuDisplay.commitBy.current = r.userId
        this.$emit('params', { params: { commitBy: r.userId }, data: r, display: r.userName, type: 'commitBy' })
      },
      selectLevel(r) {
        this.menuDisplay.collectionLevel.current = r.dictKey
        this.$emit('params', { params: { collectionLevel: r.dictKey }, data: r, display: r.dictValue, type: 'collectionLevel' })
      },
      selectDate(r) {
        if (r.name) {
          this.menuDisplay.chronicleDates.current = r.name
          this.$emit('params', { params: { chronicleDates: r.name }, data: r, display: r.name, type: 'chronicleDates' })
        } else {
          if (this.menuDisplay.chronicleDates.rangeDate.length) {
            const range = this.menuDisplay.chronicleDates.rangeDate
            this.$emit('params', { params: { startChronicleDate: range[0] || '', endChronicleDate: range[1] || '' }, data: null, display: (range[0] || '') + '-' + (range[1] || ''), type: 'chronicleDates' })
          }
        }
      },
      selectPerson(r) {
        this.menuDisplay.personAffected.current = r.personName
        this.$emit('params', { params: { personAffected: r.personName }, data: r, display: r.personName, type: 'personAffected' })
      },
      selectTopic(r) {
        this.menuDisplay.specialSubject.current = r.id
        this.$emit('params', { params: { specialSubject: r.id }, data: r, display: r.topicName, type: 'specialSubject' })
      },
      selectFileType(r) {
        this.menuDisplay.resourceType.current = r.code
        this.$emit('params', { params: { resourceType: r.code }, data: r, display: r.name, type: 'resourceType' })
      },
      clearAllFilter() {
        for (const key in this.menuDisplay) {
          const value = this.menuDisplay[key]
          value.current = null
        }
        this.currentLogs = { parent: null, logs: this.menu.sideNavigation }
        this.currentSubject = { parent: null, logs: this.menu.subjectNavigation }
        this.currentRegion = { parent: null, logs: this.menu.regionNavigation }
        this.menuDisplay.chronicleDates.rangeDate = ''
        this.menuDisplay.releaseDates.rangeDate = ''
      },
      removeFilter(v) {
        console.log(v)
        this.menuDisplay[v].current = null
        if (this.menuDisplay[v].rangeDate) {
          this.menuDisplay[v].rangeDate = ''
        }
        if (v === 'categoryId') {
          this.currentLogs = { parent: null, logs: this.menu.sideNavigation }
        }
        if (v === 'subjects') {
          this.currentSubject = { parent: null, logs: this.menu.subjectNavigation }
        }
        if (v === 'areaAffected') {
          this.currentRegion = { parent: null, logs: this.menu.regionNavigation }
        }
      },
      resetCollSelectStatus(v) {
        for (const key in v) {
          const value = v[key]
          console.log(key)
          if (Object.hasOwnProperty.call(this.menuDisplay, key)) {
            if (key === 'areaAffected') {
              this.findRegionsByCode(value, this.menu.regionNavigation)
            } else {
              this.menuDisplay[key].current = value
            }
          }
        }
      },
      findRegionsByCode(code, cates) {
         
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.regionCode === code) {
            this.currentRegion = { parent: cate, logs: cate.children }
            return cate
          } else {
            if (cate.children) {
              this.findRegionsById(code, cate.children)
            }
          }
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
    ::v-deep .el-select-dropdown__item{
      color: red($color: #000000) !important;
    }
    ::v-deep .el-input__icon{
      display: none;
    }
  
    ::v-deep .el-range-separator {
      width: 12% !important;
      line-height: 28px !important;
      color: #999 !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  
    ::v-deep .el-range__close-icon {
      width: 0px !important;
    }
  
    ::v-deep .el-range-input {
      width: 44% !important;
    }
  
  </style>
  <style src="@/styles/pc.css" scoped>
  </style>
  <style scoped>
    .collbar-page {
       width: 280px;
    }
    .menu {
      width: 280px;
    }
  
    .collbar-page  .menu .menu-header {
      height: 40px;
      width: 100%;
    }
  
    .collbar-page .menu .menu-content {
      /* margin-top: 20px; */
    }
  
    .collbar-page  .menu .menu-content .menu-content-item {
      background-color: #F3F4F9;
      margin-bottom: 10px;
      /* padding-bottom: 10px; */
    }
  
    .collbar-page .menu .menu-content .menu-content-item .menu-content-item-top {
      height: 60px;
      padding: 0 20px;
    }
  
    .collbar-page  .menu .menu-content .menu-content-item-line {
      width: 100%;
      height: 1px;
      background-color: #264480;
      opacity: 0.1;
    }
  
    .collbar-page  .menu .menu-content .menu-content-item-list {
      padding: 10px;
    }
  
    .menu-content-item-list-item-hg {
      height: 30px;
      padding: 0 10px;
    }
  
    .collbar-page  .menu .menu-content .menu-content-item-list-item-sel {
      background-color:  rgba(38, 42, 51, 0.4);
    }
  
    .collbar-page .menu .menu-content .menu-content-item-list-item-sel .menu-content-item-list-item-sel-text{
      color: #fff;
    }
  
    .menu-content-item-list-item-child {
      height: 30px;
      padding: 0 10px;
    }
  
    .menu-content-item-list-item-children {
      padding-left: 5px;
    }
  
    .menu-content-item-list-item-rang {
      width: 170px;
      height: 30px;
      border: 1px solid rgba(26, 59, 128, 0.2);
    }
  
    .menu-content-item-list-item-rang .start {
      left: 0;
      width: 60px;
      z-index: 99;
      opacity: 0;
    }
  
    .menu-content-item-list-item-rang .end {
      left: 0;
      width: 60px;
      z-index: 99;
      opacity: 0;
    }
  
    .menu-content-item-list-item-rang>div {
      padding: 0 10px;
    }
  
    .menu-content-item-list-item-button {
      width: 60px;
      height: 30px;
      margin-left: 10px;
    }
  
    .menu-content-item-more {
      height: 30px;
      padding-right: 10px;
      margin-bottom: 10px;
    }
    .transform {
      transform: rotate(180deg);
    }
  
    .character {
     margin-right: 6px;
     display: flex;
     align-items: flex-start;
     justify-content: flex-end;
    }
  
    .sel {
     background-color: rgba(147, 150, 156, 0.4);
    }
  
    .sel p {
      color: #fff;
    }
  
  </style>
  